import React, { createContext, PropsWithChildren, useContext } from "react";
import { adjectives, animals, colors, uniqueNamesGenerator } from "unique-names-generator";
import { User, useYDoc } from "../hooks/useYDoc";
import { useParams } from "react-router-dom";

interface ActiveUsers {
  activeUsers: User[];
}

const ActiveUsersContext = createContext<ActiveUsers | null>(null);

const ActiveUsersProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { id } = useParams();

  const randomUsername = uniqueNamesGenerator({
    dictionaries: [adjectives, colors, animals], // colors can be omitted here as not used
    length: 3,
  });

  const { activeUsers } = useYDoc(id);

  return <ActiveUsersContext.Provider value={{ activeUsers }}>{children}</ActiveUsersContext.Provider>;
};

const useActiveUsersProvider = () => {
  const context = useContext(ActiveUsersContext);

  if (context == null) {
    throw new Error("useActiveUsersProvider used outside of ActiveUsersProvider");
  }

  return context;
};

export { ActiveUsersProvider, useActiveUsersProvider };
